"use client";

import PropTypes from "prop-types";
import {
  BalloonIcon,
  BellIcon,
  BuildingOfficeIcon,
  ChatCircleDotsIcon,
  CurrencyInrIcon,
  GiftIcon,
  LockSimpleIcon,
  MapPinIcon,
  PackageIcon,
  QuestionIcon,
  SignInIcon,
  SignOutIcon,
  StorefrontIcon,
  UserIcon,
  UsersIcon,
  WalletIcon,
} from "@phosphor-icons/react";
import { ACCOUNT_MENU_ITEM_IDS } from "../../../constants/myAccount/menu";

const ICON_BY_MENU_ID = {
  [ACCOUNT_MENU_ITEM_IDS.FNP_CASH]: WalletIcon,
  [ACCOUNT_MENU_ITEM_IDS.MY_ORDERS]: PackageIcon,
  [ACCOUNT_MENU_ITEM_IDS.SAVED_ADDRESSES]: MapPinIcon,
  [ACCOUNT_MENU_ITEM_IDS.MY_PROFILE]: UserIcon,
  [ACCOUNT_MENU_ITEM_IDS.GIFT_VOUCHERS]: GiftIcon,
  [ACCOUNT_MENU_ITEM_IDS.NOTIFICATIONS]: BellIcon,
  [ACCOUNT_MENU_ITEM_IDS.PARTNERS]: UsersIcon,
  [ACCOUNT_MENU_ITEM_IDS.LOGOUT]: SignOutIcon,
  [ACCOUNT_MENU_ITEM_IDS.PRIVACY]: LockSimpleIcon,
  "login-register": SignInIcon,
  "contact-us": ChatCircleDotsIcon,
  faqs: QuestionIcon,
  currency: CurrencyInrIcon,
  "corp-gifts": GiftIcon,
  franchise: StorefrontIcon,
  wq: BalloonIcon,
  pq: BuildingOfficeIcon,
};

/**
 * @param {{ menuId: string, size?: number, variant?: "list" | "hub" | "enquiry", className?: string, weight?: import("@phosphor-icons/react").IconProps["weight"] }} props
 * @returns {import("react").ReactNode}
 */
export default function AccountMenuPhosphorIcon({
  menuId,
  size = 24,
  variant = "list",
  className,
  weight: weightProp,
}) {
  const Icon = ICON_BY_MENU_ID[menuId] || PackageIcon;
  const isHub = variant === "hub";
  const weight = weightProp ?? (isHub ? "duotone" : "regular");
  const variantClass =
    variant === "hub"
      ? `shrink-0 text-fnp-500`
      : variant === "enquiry"
        ? "shrink-0 text-black-900"
        : "shrink-0 text-grey-400";

  return <Icon size={size} weight={weight} className={className || variantClass} aria-hidden={true} />;
}

AccountMenuPhosphorIcon.propTypes = {
  menuId: PropTypes.string.isRequired,
  size: PropTypes.number,
  variant: PropTypes.oneOf(["list", "hub", "enquiry"]),
  className: PropTypes.string,
  weight: PropTypes.oneOf(["thin", "light", "regular", "bold", "fill", "duotone"]),
};
